import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import ThumbnailCardMedia from "arena/components/ThumbnailCardMedia";
import Link from "arena/components/Link";

const StyledCard = styled(Card)({
  width: "100%",
});

const StyledThumbnailCardMedia = styled(ThumbnailCardMedia)(({ theme }) => ({
  width: "100%",
  position: "relative",
  height: 0,
  paddingTop: "56.25%", // 16:9
  backgroundColor: theme.palette.mode === "dark" ? "black" : "rgba(0,0,0,0.07)",
  overflow: "hidden",
  borderRadius: 0,
  [theme.breakpoints.up("sm")]: {
    borderRadius: 4,
  },
}));

function getCardActionAreaProps(subItem) {
  if (subItem.link.startsWith("/")) {
    return {
      component: Link,
      to: subItem.link,
    };
  }

  return {
    component: "a",
    href: subItem.link,
    target: "_blank",
    rel: "noopener noreferrer",
  };
}

export default function GalleryMenuItemDialogItem({ item, onClick }) {
  return (
    <Box sx={{ overflow: "hidden" }}>
      <Grid container spacing={2}>
        {item.title && (
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ pl: 2 }}>
              {item.title}
            </Typography>
          </Grid>
        )}

        {item.subItems.map((subItem) => (
          <Grid item xs={6} sm={4} md={3} key={subItem.id}>
            <StyledCard>
              <CardActionArea
                {...getCardActionAreaProps(subItem)}
                onClick={onClick}
              >
                <StyledThumbnailCardMedia
                  thumbnails={subItem.preview?.thumbnails}
                />
              </CardActionArea>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

GalleryMenuItemDialogItem.propTypes = {
  onClick: PropTypes.func,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    subItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        preview: PropTypes.shape({
          thumbnails: PropTypes.arrayOf(
            PropTypes.shape({
              format: PropTypes.string.isRequired,
              url: PropTypes.string.isRequired,
              webpUrl: PropTypes.string,
            })
          ),
        }),
      })
    ),
  }),
};
